import { IToastProvider } from '../../common/types';

export const SHOW_TOAST_EVENT = "showToast";
export interface IShowToastEventData {
    message: string,
    duration: number
}

export class AppToastProvider implements IToastProvider {
    async showToast(message: string, duration: number): Promise<void> {
        publish(SHOW_TOAST_EVENT, {
            message: message,
            duration: duration
        });
        
    }

}

function subscribe(eventName: string, listener: EventListenerOrEventListenerObject) {
    document.addEventListener(eventName, listener);
}

function unsubscribe(eventName: string, listener: EventListenerOrEventListenerObject) {
    document.removeEventListener(eventName, listener);
}

function publish(eventName: string, data: IShowToastEventData) {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
}

export {subscribe, unsubscribe}